import Echo from 'laravel-echo';
import { store } from '../../redux/store';
import AppActions from '../../redux/App/actions';

require('pusher-js');

const { setWebsocket } = AppActions;

export class EchoWebsocket {
    constructor() {
        const state = store.getState();
        const { company, user, subdomain, accessToken } = state.Auth;

        this.companyId = company?.id;
        this.userId = user?.id;

        const options = {
            broadcaster: 'pusher',
            key: process.env.REACT_APP_PUSHER_APP_KEY,
            authEndpoint: `${process.env.REACT_APP_PROXY_API_URL}/auth/pusher`,
            auth: {
                headers: {
                    "Company-Subdomain": subdomain,
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    company_id: this.companyId,
                },
            },
            wsHost: process.env.REACT_APP_PUSHER_HOST,
            wsPort: process.env.REACT_APP_PUSHER_PORT,
            wssPort: process.env.REACT_APP_PUSHER_PORT,
            forceTLS: (process.env.REACT_APP_PUSHER_SCHEME === 'https'),
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
        };

        this.websocket = new Echo(options);
        store.dispatch(
            setWebsocket(this),
        );
    }

    getChannelName = (name, personalized) => {
        if (!this.companyId || !this.userId)
            return '';

        if (personalized)
            return `private-company.${this.companyId}.${this.userId}.${name}`;
        return `private-company.${this.companyId}.${name}`;
    };

    channel(name, personalized = false) {
        const channelName = this.getChannelName(name, personalized);
        return this.websocket.channel(channelName);
    }

    leaveChannel(name, personalized = false) {
        const channelName = this.getChannelName(name, personalized);
        return this.websocket.leaveChannel(channelName);
    }
}
